import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "min-h-screen min-w-full flex justify-center items-center bg-[var(--dimmed-bg)] p-4" }
const _hoisted_2 = { class: "flex w-full max-w-[1600px] h-[calc(100vh-2rem)] bg-[var(--card-bg)] shadow-md rounded-2xl overflow-hidden" }
const _hoisted_3 = { class: "flex flex-col justify-center items-center flex-[3] bg-[var(--side-bg)] text-white p-8" }
const _hoisted_4 = { class: "flex flex-col justify-center items-center space-y-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "w-44"
}, null, -1)
const _hoisted_6 = { class: "text-center font-extrabold text-3xl leading-tight max-w-[65%]" }
const _hoisted_7 = { class: "flex flex-[4] bg-white justify-center items-start overflow-y-auto p-10 h-[calc(100vh-2rem)]" }

import BaseButton from '@/components/uiv2/BaseButton.vue';
import { useAuth0 } from '@auth0/auth0-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUp',
  setup(__props) {

const { loginWithRedirect } = useAuth0();

// force Auth0 login screen, even if session exists
const handleLogin = () => {
  loginWithRedirect({
    appState: { targetUrl: '/' }, // where to go after successful login
    authorizationParams: {
      prompt: 'login', // always show login form
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('signup.alreadyhas')), 1),
          _createVNode(BaseButton, {
            type: "button",
            ghost: "",
            onClick: handleLogin
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('signup.login')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_RouterView)
      ])
    ])
  ]))
}
}

})